export const TRADE_IN_INTELLIGENCE_SUBSCRIBED = 'TRADE_IN_INTELLIGENCE_SUBSCRIBED';
export const TRADE_IN_INTELLIGENCE_REQUESTED = 'TRADE_IN_INTELLIGENCE_REQUESTED';

export const TRADE_IN_INTELLIGENCE_FETCH_REQUEST = 'TRADE_IN_INTELLIGENCE_FETCH_REQUEST';
export const TRADE_IN_INTELLIGENCE_FETCH_SUCCESS = 'TRADE_IN_INTELLIGENCE_FETCH_SUCCESS';
export const TRADE_IN_INTELLIGENCE_FETCH_FAILURE = 'TRADE_IN_INTELLIGENCE_FETCH_FAILURE';

export const TRADE_IN_INTELLIGENCE_REQUEST_ACCEPTED = 'TRADE_IN_INTELLIGENCE_REQUEST_ACCEPTED';
export const TRADE_IN_INTELLIGENCE_EVENT_RECEIVED = 'TRADE_IN_INTELLIGENCE_EVENT_RECEIVED';
export const TRADE_IN_INTELLIGENCE_SETTLED_EMPTY = 'TRADE_IN_INTELLIGENCE_SETTLED_EMPTY';
